<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid }"
    data-testid="address-step"
  >
    <OnboardingModalContent :title="$t('onboarding_address_subtitle')">
      <AddressField
        v-model="addressData"
        vertical-gap="5"
        class="address-cyan tw-pt-5 tw-pb-5"
        label-class="!tw-font-normal"
        input-class="!tw-bg-[#E1E1FF] !tw-border-0 !tw-shadow-none"
      />
      <b-loading :active="actionLoading" :is-full-page="false" />
      <template #bottom>
        <div>
          <div class="tw-flex tw-justify-center tw-my-4">
            <Button :disabled="invalid" @click="updateAddress">
              {{ $t('onboarding_save') }}
            </Button>
          </div>
          <BottomActions
            v-if="showBackButton"
            @left-action-click="$emit('prev')"
            @right-action-click="$emit('next')"
          />
          <BottomActions v-else @right-action-click="$emit('next')" />
        </div>
      </template>
    </OnboardingModalContent>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import OnboardingModalContent from './OnboardingModalContent'
import BottomActions from '@/components/onboarding/BottomActions'
import Button from '@/components/onboarding/Button'
import { addAddress } from '@/utils/address'
import OnboardingMixin from '@/components/onboarding/OnboardingMixin'
import AddressField from '@/components/shared/fields/AddressField'

export default {
  components: {
    AddressField,
    Button,
    BottomActions,
    OnboardingModalContent,
    ValidationObserver,
  },
  mixins: [OnboardingMixin],
  data() {
    return {
      addressData: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
      },
    }
  },
  computed: {
    ...mapState('onboarding', ['addressDataStored', 'actionLoading']),
  },
  mounted() {
    this.addressData = this.addressDataStored || this.addressData
  },
  methods: {
    async updateAddress() {
      const { isValid } = await this.$refs.observer.validateWithInfo()
      if (!isValid) return
      this.$store.commit('onboarding/setActionLoading', true)
      this.$store.commit('onboarding/setAddress', this.addressData)
      await addAddress(this.$axios, {
        ...this.addressData,
        address_type_id: 1,
      })
      this.$store.commit('onboarding/setActionLoading', false)
      this.$emit('next')
    },
  },
}
</script>

<style scoped>
.address-cyan::v-deep #address_state {
  background-color: #e1e1ff;
  border-width: 0px;
}
</style>
